module.exports = __webpack_public_path__ + "static/view-person-d7bab27c980eb91c1245023d7fe5f639.gif";